import { get, filter, values, map } from 'lodash'

import DeviceSubtypes from '../utils/deviceSubtypes'

import { makeGetActiveAttendant, MENU_TYPES } from './attendant'

export const getCurrentConfiguration = (state) => get(state, 'config')

export const getDeviceSubtype = (state) => get(state, 'config.deviceSubtype')

export const getIsPrintController = (state) => {
  const controlledPrinterUuids = state?.config?.configuration?.controlledPrinterUuids ?? []

  return controlledPrinterUuids.length > 0
}

export const getReceiptPrinterUuid = (state) => state?.config?.configuration?.receiptPrinterUuid

export const getIsSuitesMode = (state) => DeviceSubtypes.isSuites(getDeviceSubtype(state))

export const getIsSuitesOrTabsMode = (state) => DeviceSubtypes.isSuitesOrTabs(getDeviceSubtype(state))

export const getSelectedMenusIds = (state) => {
  if (DeviceSubtypes.isSuites(getDeviceSubtype(state)))  {
    const getActiveAttendant = makeGetActiveAttendant()
    const activeAttendant = getActiveAttendant(state)
    const allAccess = ['manager', 'supervisor'].includes(activeAttendant?.employeeRole?.role?.toLowerCase?.())
    let subtypes = get(activeAttendant, 'settings.configuration.menuSubtypes')

    if (allAccess || subtypes === null) {
      subtypes = MENU_TYPES
    } else {
      subtypes = subtypes ?? []
    }

    const menus = values(get(state, 'menus.byId'))
    const availableMenus = filter(menus, (menu) => subtypes.includes(menu.subtype) && menu.serviceType === 'POS')
    const availableMenuUuids = map(availableMenus, 'uuid')

    return availableMenuUuids
  } else {
    return get(state, 'config.configuration.menuUuids', [])
  }
}
